/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon16Solid = forwardRef('NetDownloadIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 0c.69 0 1.25.56 1.25 1.25v6.591l2.42-2.15a1.25 1.25 0 0 1 1.66 1.868l-3.503 3.114a2.75 2.75 0 0 1-3.654 0L2.67 7.56a1.25 1.25 0 1 1 1.66-1.868l2.42 2.15V1.25C6.75.56 7.31 0 8 0Z" }),
        React.createElement("path", { d: "M1.25 13.5c0-.69.56-1.25 1.25-1.25h11a1.25 1.25 0 1 1 0 2.5h-11c-.69 0-1.25-.56-1.25-1.25Z" })));
});
